<template>
  <div>
    <table
      v-if="vx_billInfo"
      class="table table-striped jambo_table bulk_action"
    >
      <thead>
        <tr class="headings fontSize14">
          <th v-for="head in HEAD" :key="head" class="column-title word_center">
            {{ head }}
          </th>
          <th v-if="vx_billInfo.cars !== 1" class="column-title word_center">
            取消
          </th>
        </tr>
      </thead>
      <tbody v-if="driver.length">
        <tr
          v-for="(row, index) in driver"
          class="pointer fontSize14"
          style="text-align: center"
          :key="row.driverCallNumber"
        >
          <td class="text-black">{{ row.driverCallNumber }}</td>
          <td class="text-black">{{ row.driverName }}</td>
          <td class="text-black">{{ row.driverPhone }}</td>
          <td class="text-black">{{ row.driverNote }}</td>
          <td class="text-black">{{ row.createdAt }}</td>
          <td class="text-black">
            <button
              class="mybtnstyle btn-default"
              :class="row.driverState === 1 ? 'btn-default' : 'btn-danger'"
              @click="deal(index)"
            >
              {{ row.driverState === 1 ? '配對' : '已配對' }}
            </button>
          </td>
          <td v-if="vx_billInfo.cars !== 1">
            <button class="mybtnstyle btn-default" @click="cancel(index)">
              取消
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { reqDeal, reqCancel } from '@/api/reservation'
import { Notification, MessageBox } from 'element-ui'
import { mapState, mapActions } from 'vuex'
import { carState } from '@/constants/tableHead'

export default {
  methods: {
    ...mapActions('reservation', {
      vx_fetchOrderDetail: 'fetchOrderDetail',
    }),
    async updateDeal(value) {
      try {
        const { success } = await reqDeal({
          reservationId: this.vx_billInfo.orderId,
          driverId: this.vx_driverState[value].driverId,
          teamId: this.vx_driverState[value].driverTeamId,
          reservationCarStateId:
            this.vx_driverState[value].reservationCarStateId,
          driverState: this.vx_driverState[value].driverState,
        })
        if (success) {
          Notification({
            title: '更新成功',
            type: 'success',
          })
          /* 預約單 */
          this.vx_fetchOrderDetail()
          /* 叫車紀錄總查詢 */
        } else {
          Notification({
            title: '失敗',
            message: '更新失敗，請稍後再試',
            type: 'error',
          })
        }
      } catch (e) {
        Notification({
          title: '失敗',
          message: '更新失敗，請稍後再試',
          type: 'error',
        })
        console.error(e)
      }
    },
    async updateCancel(value) {
      try {
        const { success } = await reqCancel({
          reservationId: this.vx_billInfo.orderId,
          driverId: this.vx_driverState[value].driverId,
        })
        if (success) {
          Notification({
            title: '取消成功',
            type: 'success',
          })
          this.vx_fetchOrderDetail()
        } else {
          Notification({
            title: '失敗',
            message: '取消失敗，請稍後再試',
            type: 'error',
          })
        }
      } catch (e) {
        Notification({
          title: '失敗',
          message: '取消失敗，請稍後再試',
          type: 'error',
        })
        console.error(e)
      }
    },
    deal(value) {
      const method = this.vx_billInfo.callMethod
      if (method === 0 || method === 3 || method === 4) {
        MessageBox.confirm(
          '由於是app、line預約，所以有先與乘客確認嗎?',
          '提示',
          {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        ).then(() => {
          this.updateDeal(value)
        })
      } else {
        this.updateDeal(value)
      }
    },
    async cancel(value) {
      const method = this.vx_billInfo.callMethod
      if (method === 0 || method === 3 || method === 4) {
        if (!confirm('由於是app、line預約，所以有先與乘客確認嗎?')) return
        MessageBox.confirm(
          '由於是app、line預約，所以有先與乘客確認嗎?',
          '提示',
          {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        ).then(() => {
          this.updateCancel(value)
        })
      } else {
        this.updateCancel(value)
      }
    },
  },
  computed: {
    ...mapState('reservation', {
      vx_driverState: (state) => state.modal.driverState,
      vx_billInfo: (state) => state.modal.billInfo,
    }),
    driver() {
      if (this.vx_driverState) {
        return this.vx_driverState.sort(
          (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
        )
      }
      return []
    },
  },
  created() {
    this.HEAD = carState
  },
}
</script>

<style scoped>
.text-black {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/pages/reservation/components/CarStateTable.vue